import { render } from "./projectType.vue?vue&type=template&id=7a5612ca&scoped=true&ts=true"
import script from "./projectType.vue?vue&type=script&lang=ts"
export * from "./projectType.vue?vue&type=script&lang=ts"

import "./projectType.vue?vue&type=style&index=0&id=7a5612ca&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5612ca"]])

export default __exports__